// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1x5T5","item":"PaymentsMobile_item__3rfW-","label":"PaymentsMobile_label__3smvo","amount":"PaymentsMobile_amount__3D-A9"};